var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddAttribute = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.548 6.458c.318-.028.633.084.859.307l8.02 7.913c.42.415.42 1.088 0 1.503l-4.57 4.508a1.088 1.088 0 0 1-1.522 0l-8.02-7.914a1.055 1.055 0 0 1-.31-.847l.38-4.132a1.07 1.07 0 0 1 .975-.962l4.188-.376ZM7.02 8.416a1.45 1.45 0 0 0-2.03 0 1.403 1.403 0 0 0 0 2.004 1.45 1.45 0 0 0 2.03 0c.56-.553.56-1.45 0-2.004ZM17.138 3c.524 0 .951.421.951.938v1.934h1.96c.524 0 .951.422.951.939v.038a.947.947 0 0 1-.95.938h-1.96v1.925a.947.947 0 0 1-.952.938h-.03a.942.942 0 0 1-.96-.938V7.787h-1.95a.95.95 0 0 1-.96-.947v-.03a.962.962 0 0 1 .96-.938h1.95V3.938c0-.516.427-.938.96-.938h.03Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddAttribute);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add_attribute.379f2174111bf64c3c8beec0d2e4a4e4.svg";